
import React from 'react';
import { formatDate } from 'utils/dateFormater';
import { downloadBase64Data } from 'utils/fileHelper';

interface AuditType {
    item: any;
    setDeleteDoc: any;
    setIsDeleteModalOpen: any;
}

const DocumentRow: React.FC<AuditType> = ({ item, setDeleteDoc, setIsDeleteModalOpen }) => {
  const getFileType = (fileName: string): string | null => {
    const parts = fileName?.split('.');
    return parts?.length > 1 ? parts.pop() || null : null;
  };


  return (
    <>
      <div className='audit-doc-tabe-row'>
        <div className='audit-doc-tabe-row'>
          <div className='audit-doc-tabe-row-frame'>
            <div className='audit-doc-tabe-row-frame-left'>
              <div className='audit-doc-tabe-row-frame-left-file-type'>
                {getFileType(item.uploadedFile.name) === 'csv' || getFileType(item.uploadedFile.name) === 'xls' || getFileType(item.uploadedFile.name) === 'xlsx' ?
                  (<div>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='30' viewBox='0 0 24 30' fill='none'>
                      <path d='M0.75 4C0.75 2.20507 2.20507 0.75 4 0.75H15C15.0412 0.75 15.0807 0.766365 15.1098 0.795496L23.2045 8.89016C23.2336 8.9193 23.25 8.9588 23.25 9V26C23.25 27.7949 21.7949 29.25 20 29.25H4C2.20508 29.25 0.75 27.7949 0.75 26V4Z' stroke='#2E3036' strokeWidth='1.5' />
                      <path d='M15 0.375V5C15 7.20914 16.7909 9 19 9H23.625' stroke='#2E3036' strokeWidth='1.5' />
                    </svg>
                    <div className='audit-doc-tabe-row-frame-left-file-type-xml csv-file-tag'>
                                          XLS
                    </div>
                  </div>) : (getFileType(item.uploadedFile.name) === 'pdf' ?
                    (<div>
                      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='30' viewBox='0 0 24 30' fill='none'>
                        <path d='M0.75 4C0.75 2.20507 2.20507 0.75 4 0.75H15C15.0412 0.75 15.0807 0.766365 15.1098 0.795496L23.2045 8.89016C23.2336 8.9193 23.25 8.9588 23.25 9V26C23.25 27.7949 21.7949 29.25 20 29.25H4C2.20508 29.25 0.75 27.7949 0.75 26V4Z' stroke='#2E3036' strokeWidth='1.5' />
                        <path d='M15 0.375V5C15 7.20914 16.7909 9 19 9H23.625' stroke='#2E3036' strokeWidth='1.5' />
                      </svg>
                      <div className='audit-doc-tabe-row-frame-left-file-type-xml pdf-file-tag'>
                                          PDF
                      </div>
                    </div>) : (
                      getFileType(item.uploadedFile.name) === 'png' || getFileType(item.uploadedFile.name) === 'img' || getFileType(item.uploadedFile.name) === 'jpeg' ?
                        (<div>
                          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='30' viewBox='0 0 24 30' fill='none'>
                            <path d='M0.75 4C0.75 2.20507 2.20507 0.75 4 0.75H15C15.0412 0.75 15.0807 0.766365 15.1098 0.795496L23.2045 8.89016C23.2336 8.9193 23.25 8.9588 23.25 9V26C23.25 27.7949 21.7949 29.25 20 29.25H4C2.20508 29.25 0.75 27.7949 0.75 26V4Z' stroke='#2E3036' strokeWidth='1.5' />
                            <path d='M15 0.375V5C15 7.20914 16.7909 9 19 9H23.625' stroke='#2E3036' strokeWidth='1.5' />
                          </svg>
                          <div className='audit-doc-tabe-row-frame-left-file-type-xml img-file-tag'>
                        IMG
                          </div>
                        </div>) : (
                          getFileType(item.uploadedFile.name) === 'doc' || getFileType(item.uploadedFile.name) === 'docx' ?
                            (<div>
                              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='30' viewBox='0 0 24 30' fill='none'>
                                <path d='M0.75 4C0.75 2.20507 2.20507 0.75 4 0.75H15C15.0412 0.75 15.0807 0.766365 15.1098 0.795496L23.2045 8.89016C23.2336 8.9193 23.25 8.9588 23.25 9V26C23.25 27.7949 21.7949 29.25 20 29.25H4C2.20508 29.25 0.75 27.7949 0.75 26V4Z' stroke='#2E3036' strokeWidth='1.5' />
                                <path d='M15 0.375V5C15 7.20914 16.7909 9 19 9H23.625' stroke='#2E3036' strokeWidth='1.5' />
                              </svg>
                              <div className='audit-doc-tabe-row-frame-left-file-type-xml doc-file-tag'>
                        DOC
                              </div>
                            </div>) : (

                              <div>
                                <svg xmlns='http://www.w3.org/2000/svg' width='24' height='30' viewBox='0 0 24 30' fill='none'>
                                  <path d='M0.75 4C0.75 2.20507 2.20507 0.75 4 0.75H15C15.0412 0.75 15.0807 0.766365 15.1098 0.795496L23.2045 8.89016C23.2336 8.9193 23.25 8.9588 23.25 9V26C23.25 27.7949 21.7949 29.25 20 29.25H4C2.20508 29.25 0.75 27.7949 0.75 26V4Z' stroke='#2E3036' strokeWidth='1.5' />
                                  <path d='M15 0.375V5C15 7.20914 16.7909 9 19 9H23.625' stroke='#2E3036' strokeWidth='1.5' />
                                </svg>
                                <div className='audit-doc-tabe-row-frame-left-file-type-xml'>

                                </div>
                              </div>
                            )
                        )
                    )
                  )
                }
              </div>
              <div className='audit-doc-tabe-row-frame-left-text'>
                {item.uploadedFile.name}
              </div>
            </div>
            <div className='audit-doc-tabe-row-frame-right'>
              <div>
                <div className='audit-doc-tabe-row-frame-right-text'>{typeof item.uploadedFile.dateAdded === 'string' ? formatDate(item.uploadedFile.dateAdded.substring(0, 10)) : ''}</div>
              </div>
            </div>
            {
              item.uploadedFile.source ? (
                <div className='audit-doc-tabe-row-frame-right'>
                  <div className='audit-doc-tabe-row-frame-right-status' style={{ width: '160px' }}>
                    <svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none'>
                      <circle cx='4' cy='4' r='3' fill='#17B26A'/>
                    </svg>
                    <div className='audit-doc-tabe-row-frame-right-status-text'>Source Doc</div>
                  </div>
                </div>
              ) : (
                <div className='audit-doc-tabe-row-frame-right'>
                  <div className='audit-doc-tabe-row-frame-right-status' style={{ width: '160px' }}>
                    <svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8' fill='none'>
                      <circle cx='4' cy='4' r='3' fill='#2E3036'/>
                    </svg>
                    <div className='audit-doc-tabe-row-frame-right-status-text'>Additional</div>
                  </div>
                </div>
              )
            }
            <div className='audit-doc-tabe-row-frame-icons'>
              {!item.uploadedFile.source && <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none' cursor={'pointer'} onClick={() => {
                setDeleteDoc(item);
                setIsDeleteModalOpen(true);
              }}>
                <path d='M6.75 2.25H11.25M2.25 4.5H15.75M14.25 4.5L13.724 12.3895C13.6451 13.5732 13.6057 14.165 13.35 14.6138C13.1249 15.0088 12.7854 15.3265 12.3762 15.5248C11.9115 15.75 11.3183 15.75 10.132 15.75H7.86799C6.68168 15.75 6.08852 15.75 5.62375 15.5248C5.21457 15.3265 4.87507 15.0088 4.64999 14.6138C4.39433 14.165 4.35488 13.5732 4.27596 12.3895L3.75 4.5M7.5 7.875V11.625M10.5 7.875V11.625' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
              </svg>}
              <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none' cursor={'pointer'} onClick={() => downloadBase64Data(item.uploadedFile.base64, item.uploadedFile.name)}>
                <path d='M6 12.75L9 15.75M9 15.75L12 12.75M9 15.75V9M15 12.5571C15.9161 11.8005 16.5 10.656 16.5 9.375C16.5 7.09683 14.6532 5.25 12.375 5.25C12.2111 5.25 12.0578 5.1645 11.9746 5.0233C10.9965 3.36363 9.19082 2.25 7.125 2.25C4.0184 2.25 1.5 4.7684 1.5 7.875C1.5 9.42458 2.12659 10.8278 3.14021 11.8451' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentRow;
